import React, { useMemo } from "react";
import PropTypes from "prop-types";

import KMKTable from "../../../Common/Table/KMKTable";

function ErrorRecordTable({ data, loading = false, tableMaxHeight = "500px" }) {
  const columns = useMemo(
    () => [
      {
        id: "ERROR",
        name: "Error",
        sortable: false,
        align: "left",
        width: 150,
        style: { wordBreak: "break-word" },
        renderHeadCell: (name) => name,
        renderValueCell: (val, record, index) => val || "_",
      },
      {
        id: "ERR_ROW_NUMBER",
        name: "Row Number",
        sortable: false,
        align: "left",
        width: 100,
        style: { width: "100px", maxWidth: "100px", wordBreak: "break-word" },
        renderHeadCell: (name) => name,
        renderValueCell: (val, record, index) => val || "-",
      },
      {
        id: "ERROR_RECORD",
        name: "Error Records",
        sortable: false,
        align: "left",
        width: 250,
        renderHeadCell: (name) => name,
        renderValueCell: (val, record, index) => val || "-",
      },
      {
        id: "ERROR_COLUMN",
        name: "Error Column",
        sortable: false,
        align: "left",
        width: 250,
        renderHeadCell: (name) => name,
        renderValueCell: (val, record, index) => val || "-",
      },
    ],
    []
  );

  return (
    <KMKTable
      loading={loading}
      columns={columns}
      noDataText={"No data available"}
      data={data}
      boldHeader
      tableProps={{ size: "small", stickyHeader: true }}
      pagination={false}
      sortingProperties={{}}
      paginationProperties={{}}
      dataIdKey="id"
      tableContainerStyle={{ maxWidth: "100%", maxHeight: tableMaxHeight }}
    />
  );
}

ErrorRecordTable.propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  tableMaxHeight: PropTypes.string,
};

export default ErrorRecordTable;
